import { useSelector } from 'react-redux';
import { PRICE_RANGE_LIST } from '../../../../utils/constants/PriceRangeList';
import { useNeighborhoodsInMarket } from './useNeighborhoodsInMarket';
import { intersection } from 'lodash';

export const useFilterLists = () => {
  const { market } = useSelector((state) => state.markets);
  const { atmospheres, cuisines, accolades } = useSelector((state) => state);
  const neighborhoodsInMarket = useNeighborhoodsInMarket();

  const venuesInMarket = market.venues.items;

  const priceRangeList = PRICE_RANGE_LIST.reduce((list, priceRange) => {
    if (venuesInMarket.some((venue) => venue.priceRange === priceRange.name)) {
      list.push(priceRange);
    }

    return list;
  }, []);

  const atmospheresList = atmospheres.list.reduce((list, atmosphere) => {
    if (
      venuesInMarket.some((venue) =>
        venue.atmospheres?.items.some(
          (item) => item.atmosphere.id === atmosphere.id
        )
      )
    ) {
      list.push(atmosphere);
    }

    return list;
  }, []);

  const cuisinesList = cuisines.list.reduce((list, cuisine) => {
    if (
      venuesInMarket.some((venue) =>
        venue.cuisines?.items.some((item) => item.cuisine.id === cuisine.id)
      )
    ) {
      list.push(cuisine);
    }

    return list;
  }, []);

  const tagIdsInMarket = new Set();
  venuesInMarket.forEach((venue) => {
    venue.tags?.items.forEach((item) => {
      tagIdsInMarket.add(item.tag.id);
    });
  });

  const awardIdsInMarket = new Set();
  venuesInMarket.forEach((venue) => {
    venue.awards?.items.forEach((item) => {
      awardIdsInMarket.add(item.award.id);
    });
  });

  const accoladesList = accolades.list.reduce((list, accolade) => {
    const tagIdsOnAccolade = accolade.tags?.items.map((tag) => tag.tagId);
    const awardIdsOnAccolade = accolade.awards?.items.map(
      (award) => award.awardId
    );
    if (
      intersection(tagIdsOnAccolade, Array.from(tagIdsInMarket.values()))
        .length > 0 ||
      intersection(awardIdsOnAccolade, Array.from(awardIdsInMarket.values()))
        .length > 0
    ) {
      list.push(accolade);
    }
    return list;
  }, []);

  const sortList = (list) => list.sort((a, b) => a.name.localeCompare(b.name));

  return {
    priceRangeList: sortList(priceRangeList),
    neighborhoodsList: sortList(neighborhoodsInMarket),
    atmospheresList: sortList(atmospheresList),
    cuisinesList: sortList(cuisinesList),
    accoladesList: sortList(accoladesList),
  };
};
